import React, { Component } from 'react';
import { Card, Row, Col, Table, Button, Input, ButtonGroup, Alert as Alert2 } from "reactstrap";
import { api, filterHelper } from "../helpers";
import { TextFilter, FilterSet, ActiveToggleFilter, Pager } from "../components";
import Alert from "react-s-alert";
import _ from "lodash";
import './Site.css';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const emptyProductType = {
  name: '',
}

export default class ProductType extends Component {
  static displayName = ProductType.name;
  constructor(props) {
    super(props);
    this.state = {
      message: null,
      messageColor: null,
      isMessageVisible: false,
      editProductType: null,
      productTypeList: [],
      filters: [],
      pagedList: null,
      sortColumn: "Name",
      sortAscending: true,
    }
    this.addProductType = this.addProductType.bind(this);
    this.refreshList = this.refreshList.bind(this);
    this.onInputChange = this.onInputChange.bind(this);
    this.onCancel = this.onCancel.bind(this);
    this.onSave = this.onSave.bind(this);
    this.clearFilters = this.clearFilters.bind(this);
    this.onChangeFilter = this.onChangeFilter.bind(this);
    this.setPage = this.setPage.bind(this);
  }

  componentDidMount() {
    this.onChangeFilter({
      filterName: "activeOnly",
      value: true,
      filteredDisplay: "Active Only"
    });
  }

  refreshList(sortColumn, sortAscending, filters, pageNumber) {
    const resolvedFilters = filters || this.state.filters;
    const resolvedSort = {
      sortColumn: sortColumn || this.state.sortColumn,
      sortAscending: sortAscending || this.state.sortAscending
    };
    const payload = {
      activeOnly: null,
      name: null,
      ...resolvedSort,
      ...filterHelper.filtersToObject(resolvedFilters),
      pageSize: 50,
      page: pageNumber || (this.state.pagedList ? this.state.pagedList.pageNumber : 1)
    };
    api.post("Admin/ProductTypes", payload)
      .then(response => {
        if (response && response.data) {
          this.setState({
            ...resolvedSort,
            pagedList: {
              list: response.data.dataSource,
              page: response.data.page,
              pageSize: response.data.pageSize,
              totalItems: response.data.totalItems,
              totalPages: response.data.totalPages
            },
            filters: resolvedFilters,
            editProductType: null,
            message: null,
            messageColor: null,
            isMessageVisible: false,
          });
        }
      })
  }

  clearFilters() {
    const filters = [];
    this.setState({ filters: filters });
    this.refreshList(null, null, filters);
  }

  onChangeFilter(changedFilter) {
    const filters = filterHelper.getFilters(
      this.state.filters,
      changedFilter
    );
    this.setState({ filters: filters });
    this.refreshList(null, null, filters, 1);
  }

  setPage(page) {
    this.refreshList(null, null, null, page);
  }

  onDismiss() {
    this.setState({
      isMessageVisible: !this.state.isMessageVisible,
      message: null,
      messageColor: null
    });
  }

  addProductType() {
    this.setState({
      editProductType: emptyProductType
    })
  }

  onInputChange(e, fieldName) {
    this.setState({
      editProductType: { ...this.state.editProductType, [fieldName]: e.target.value }
    })
  }

  onCancel() {
    this.setState({
      editProductType: null
    });
  }

  onSave() {
    let type = Object.assign({}, this.state.editProductType);
    if (type.name === "") {
      this.setState({ message: "Product Type name is required.", messageColor: "danger" });
      return;
    }
    let payload = {
      Name: type.name,
    }
    if (type.id) {
      payload.Id = type.id;
    }
    api.post("Admin/SaveProductType", payload)
      .then(response => {
        if (response.data.success) {
          Alert.success(`${type.name} has been saved.`)
          this.refreshList();
          this.props.refreshAll();

        } else {
          Alert.error("An error occurred.  The product type could not be created at this time.")
        }
      }).catch(error => Alert.error("There was an error creating the Product Type."));
  }

  onEdit(productTypeId) {
    let list = this.state.pagedList.list.slice();
    let type = _.find(list, t => {
      return t.id === productTypeId
    })
    this.setState({
      editProductType: type
    })
  }

  onDelete(productTypeId) {
    if (!window.confirm(`Are you sure you'd like to delete this product type?`)) return;

    api.delete(`Admin/DeleteProductType/${productTypeId}`)
      .then(response => {
        if (response.data.success) {
          Alert.success("Product Type was deleted.")
          this.refreshList();
        } else {
          Alert.error("An error occurred. Product Type cannot be deleted at this time.")
        }
      }).catch(error => {
        Alert.error("There was an error deleting the Product Type.")
      });
  }

  onRevive(productTypeId) {
    api.post("Admin/ReviveProductType", productTypeId)
      .then(response => {
        if (response.data.success) {
          Alert.success("Product Type was revived.")
          this.refreshList();
        } else {
          Alert.error("An error occurred. Product Type cannot be revived at this time.")
        }
      }).catch(error => Alert.error("There was an error reviving the Product Type."));
  }

  render() {
    let editProductType = this.state.editProductType;
    return (
      <div>
        <Row>
          <Col><h5>Product Types</h5></Col>
          <Col className="mr-3">
            {this.state.editProductType ? null : (
              <Button size="sm" color="success" className="float-right" onClick={this.addProductType}>Add New Product Type</Button>
            )}
          </Col>
        </Row>
        {this.state.message ? (
          <Alert2 color={this.state.messageColor} toggle={() => this.onDismiss()}>{this.state.message}</Alert2>
        ) : null}

        {this.state.editProductType ? (
          <Card className="p-2">
            <Row>
              <Col>Name: <Input type="text" name="name" id="name" onChange={(e) => this.onInputChange(e, "name")} value={editProductType.name} /></Col>
            </Row>
            <Row className="mt-2">
              <Col>
                <ButtonGroup className="float-right">
                  <Button size="sm" color="secondary" className="buttonGroupSpacing" onClick={this.onCancel}>Cancel</Button>
                  <Button size="sm" className="cbdmdPrimary buttonGroupSpacing" onClick={() => this.onSave()}>{editProductType.id ? "Update" : "Save"}</Button>
                </ButtonGroup>
              </Col>
            </Row>
          </Card>
        ) : null}

        <Row className="rowSpacing cursor">
          <Col>
            <FilterSet filters={this.state.filters} clearFilters={this.clearFilters} childrenClassName="pt-2 cursor">
              <Col xs="3">
                <TextFilter
                  filterName="name"
                  displayName=" Name"
                  descriptionPrefix="contains"
                  onChangeCallback={this.onChangeFilter}
                />
              </Col>
              <Col xs="2">
                <ActiveToggleFilter
                  filterName="activeOnly"
                  displayName="Active Only"
                  onChangeCallback={this.onChangeFilter}
                  value={filterHelper.get_value(
                    "activeOnly",
                    this.state.filters
                  )}
                />
              </Col>
            </FilterSet>
          </Col>
        </Row>

        <Row className="d-flex flex-row mt-2">
          <Col>
            <Table size="sm" responsive>
              <thead>
                <tr>
                  <th>Name</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {this.state.pagedList && this.state.pagedList.list.length > 0 ? (
                  this.state.pagedList.list.map(type => (
                    <tr key={`pg-${type.id}`}>
                      <td>{type.name}</td>
                      <td>
                        <ButtonGroup className="float-right">
                          {type.deactivatedAt === null ? (
                            <React.Fragment>
                              <Button size="sm" className="cbdmdPrimary buttonGroupSpacing" onClick={() => this.onEdit(type.id)} disabled={this.state.editProductType !== null} title="Edit">
                                <FontAwesomeIcon
                                  icon="edit"
                                  className="ml-1 mt-0 mb-0 mr-1 pointer"
                                  title="Edit"
                                />
                              </Button>
                              <Button size="sm" className="cbdmdDanger buttonGroupSpacing" onClick={() => this.onDelete(type.id)} disabled={this.state.editProductType !== null} title="Delete">
                                <FontAwesomeIcon
                                  icon="trash-alt"
                                  className="ml-1 mt-0 mb-0 mr-1 pointer "
                                  title="Delete"
                                />

                              </Button>
                            </React.Fragment>
                          ) : (
                              <Button size="sm" className="cbdmdInfoTeal" onClick={() => this.onRevive(type.id)} disabled={this.state.editProductType !== null}>Revive</Button>
                            )}
                        </ButtonGroup>
                      </td>
                    </tr>
                  ))
                ) : (
                    <tr>
                      <td>
                        No Records available
                    </td>
                    </tr>
                  )}
              </tbody>
            </Table>
            <Pager {...this.state.pagedList} callBack={this.setPage} />

          </Col>
        </Row>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/ProductType.js